module.exports = __webpack_public_path__ + "static/media/team-img3.1a38df02.jpg";